import { request } from './http';
import { config } from './config';
import type { Profile } from '../domain/types';

type ProfileEnvelope = { data: Profile };

// GET /client/profile?country={code} — flutter_client wraps the body in { data }.
export async function getProfile(country: string = config.defaultCountry): Promise<Profile> {
  const res = await request<ProfileEnvelope>(`/client/profile?country=${encodeURIComponent(country)}`);
  return res.data;
}
